<template>
  <!-- 添加用户弹框 -->
  <el-dialog
    title="添加角色"
    width="50%"
    :visible.sync="userAddVisible"
    :close-on-click-modal="false"
  >
    <el-form
      ref="roleAddForm"
      :model="role"
      label-width="120px"
      :rules="roleAddRules"
    >
      <el-form-item prop="roleName" label="角色名称">
        <el-input v-model="role.roleName" placeholder="请输入角色名称" />
      </el-form-item>
      <!-- <el-form-item prop="isSystem" label="是否是系统角色">
        <el-radio v-model="role.isSystem" :label="true">是</el-radio>
        <el-radio v-model="role.isSystem" :label="false">否</el-radio>
      </el-form-item> -->
    </el-form>
    <div slot="footer">
      <el-button type="primary" @click="onSubmit">创建</el-button>
      <el-button @click="userAddVisible = false">取消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import * as api from "@/api/factory/user/list";
export default {
  name: "RoleAdd",
  data() {
    return {
      userAddVisible: false,
      role: {
        createTime: 0,
        factoryId: 0,
        id: 0,
        isSystem: false,
        roleName: "",
        updateTime: 0,
      },
      // roleList: [],
      // canLogin: false,
      roleAddRules: {
        //   验证用户名是否合法
        roleName: [
          { required: true, message: "请输入角色名", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    // 外部调用，展示添加用户弹框
    show() {
      this.userAddVisible = true;
    },
    onSubmit() {
      this.$refs.roleAddForm.validate((valid) => {
        if (!valid) return;
        api.roleAdd(this.role).then((res) => {
          console.log(res);
          this.$refs.roleAddForm.resetFields();
          this.$emit("update");
          this.userAddVisible = false;
          this.$Message.success("添加角色成功！");
        });
      });
    },
  },
  watch: {},
  mounted() {},
};
</script>

<style lang="less" scoped>
.el-select {
  width: 100%;
}
</style>
